import { RootPage } from '../page';
import $api from '../../api';
import countries, { usStates } from '../../utils/countries';
import { koComponent } from '../../ko-utils/index';

class SettingsBillingView extends RootPage {
    constructor() {
        super();

        koComponent('cancel-request-dialog', CancelRequestDialog)(this);

        this.countries = ko.observableArray(countries);
        this.usStates = ko.observableArray(usStates);
        this.upgradeOptionsVisible = ko.observable(false);


        this.data = ko.mapping.fromJS(this.getServerSideData('companyBilling'));
        this.groupedPlans = this.getServerSideData('groupedPlans');
        this.allPricingPlans = this.getServerSideData('allPricingPlans');

        this.data.countryCode.subscribe((val) => {
            if (val != 'US') {
                this.data.state(null);
            } else {
                this.data.state('AL');
            }
        });

        const allMausRaw = [];
        for (const key of Object.keys(this.groupedPlans)) {
            allMausRaw.push(...this.getPrices(key, 1).map(i => i.MAUs));
            allMausRaw.push(...this.getPrices(key, 2).map(i => i.MAUs));
        }
        this.allMaus = allMausRaw.filter(onlyUnique).sort((a, b) => (a - b))

        this.billingAddressModalMode = ko.observable('payment');
        this.lastSelectedPlan = ko.observable();
        this.lastSelectedQ = ko.observable();

        this.invalidVat = ko.observable(false);
        this.invalidCompanyName = ko.observable(false);
        this.invalidAddressLine1 = ko.observable(false);
        this.invalidPostalCode = ko.observable(false);
        this.invalidCity = ko.observable(false);

        this.publicSelectedPeriod = ko.observable(1);
        //this.publicSelectedPlanId = ko.observable(this.pricingPlans.filter(i => i.period == 2)[0].id);
        this.selectedMaus = ko.observable();

        this.upgradePlanId = ko.observable();
        this.upgradePlanName = ko.observable();
        this.upgradePlanPeriod = ko.observable();
        this.upgradePlanMaus = ko.observable();
        this.upgradePlanPrice = ko.observable();
        this.upgradePlanCurrency = ko.observable();

        this.publicSelectedPrice = (planName) => ko.computed(() => {
            const plan = this.getPrices(planName, this.publicSelectedPeriod())
                .filter(i => i.MAUs == this.selectedMaus())[0];

            if (plan && plan.Period == 1) {
                return `${plan.Price.toLocaleString()} ${plan.Currency} / month`;
            } else if (plan && plan.Period == 2) {
                return `${plan.Price.toLocaleString()} ${plan.Currency} / year`;
            } else {
                return 'Contact Us'
            }
        });

        this.selectedPricingPlanVariants = ko.computed(() => {
            return this.allMaus.map(i => {
                return {
                    id: i,
                    text: `Up to ${i.toLocaleString()} users/mo`
                }
            });
        });

        this.billingEmail = ko.observable(this.data ? ko.unwrap(this.data.billingEmail) : '');
    }

    getPrices(planName, period) {
        const plan = this.groupedPlans[planName];

        const periodPrices = period == 1 ? plan.MonthlyVariants : plan.AnnualVariants;

        return periodPrices || [];
    }

    onInit() {

    }

    letsTalk() {
        window.location.href = 'https://productfruits.com/contact';
    }

    async updateBillingEmail() {
        const response = await fetch('/stripe/updatebillingemail?email=' + encodeURIComponent(this.billingEmail()), {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        });
        const respObj = await response.json();

        this.showToast('Billing e-mail updated.')
    }

    showBillingAddressModalWithPayment(planName) {
        const planPrice = this.getPrices(planName, this.publicSelectedPeriod()).filter(i => i.MAUs == this.selectedMaus())[0];

        if (!planPrice) {
            this.showToast('Purchasing error, please contact us.')
            return;
        }

        this.showBillingAddressModal('payment', planPrice.Id, this.selectedMaus());

        TRACK_EVENT('Conversion', 'AddPaymentInfo');
    }

    showUpgradeOptions(show) {
        this.upgradeOptionsVisible(show);
    }

    getUpgradeableOption(currentPlanName, currentMaus, currentCycle, currentType, newPlanName, newType) {
        var currentCycleToTest;
        switch (currentCycle) {
            case 1: // Monthly
                currentCycleToTest = '1';
                break;
            case 2: // Yearly
                currentCycleToTest = '2';
                break;
        }

        // Always allow switch to any Custom plan
        if (newType === 'Custom') {
            return 'upgrade';
        }

        // Check whether it's our current plan
        if ((newPlanName === currentPlanName) &&
            (this.selectedMaus() === currentMaus) &&
            (this.publicSelectedPeriod() === currentCycleToTest)) {
            return 'same';
        }

        // Don't allow switch from Custom plan to Core/Boost
        if (currentType === 'Custom') {
            if (newType !== 'Custom') {
                return 'contact';
            }
        }

        // Don't allow switch from Boost to Core
        if (currentPlanName === 'Boost') {
            if (newPlanName === 'Core') {
                return 'contact';
            }
        }

        // Don't allow switch from Yearly to Monthly
        if (currentCycleToTest === '2') { // Yearly
            if (this.publicSelectedPeriod() === '1') { // Monthly
                return 'contact';
            }
        }

        // Don't allow switch to less MAUs
        if (currentMaus > this.selectedMaus()) {
            return 'contact';
        }

        return 'upgrade';
    }

    showBillingAddressModalWithPaymentEnterprise(planId, q) {
        this.showBillingAddressModal('payment', planId, q);

        TRACK_EVENT('Conversion', 'AddPaymentInfo');
    }

    showBillingAddressModal(mode, planId, q) {
        this.billingAddressModalMode(mode);
        this.lastSelectedPlan(planId);
        this.lastSelectedQ(q);

        $('#billing-address-dialog').modal({
            backdrop: 'static'
        })
    }

    showCancelRequestModal() {
        try {
            const churnSurveyId = 'bc3613d8-57eb-4112-9e90-5a596da901ae';

            window.productFruits.api.surveys.listen('survey-closed', (e) => {
                console.log('AAA', e);
                if (e.surveyId == churnSurveyId) {
                    fetch('/stripe/cancelsubscription?f=' + encodeURIComponent((e.answers?.length == 0) ? 'No feedback provided' : ''), {
                        method: 'POST'
                    }).then(() => {
                        window.location.reload();
                    });
                }
            })
            window.productFruits.api.surveys.startSurvey(churnSurveyId);
        } catch (e) {
            console.log('Survey problem', e);
            this.showDialog('cancel-request-dialog');
        }
    }

    presaveChecks() {
        const me = this;
        this.invalidVat(false);

        return isInvalid('companyName') |
            isInvalid('addressLine1') |
            isInvalid('postalCode') |
            isInvalid('city');

        function isInvalid(prop) {
            const data = ko.mapping.toJS(me.data);
            const res = !data[prop];
            me['invalid' + (prop.charAt(0).toUpperCase() + prop.slice(1))](res);
            return res;
        }
    }

    async saveBillingDetails() {
        if (this.presaveChecks()) return;

        this.startSubmitting();

        const data = ko.mapping.toJS(this.data);

        try {
            const response = await fetch('/stripe/updatebillingaddress', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            });
            const session = await response.json();

            if (response.status == 400) {
                if (session.error == 2) {
                    this.invalidVat(true);
                } else {
                    alert('Some fields are invalid.');
                }
                this.stopSubmitting();
                return;
            }

            TRACK_EVENT('Billing', 'Billing address saved');

            window.location.reload();
        } catch (error) {
            this.stopSubmitting();
            console.error('Error:', error);
            if (error && error.error == 1) {
                alert('Error - some fields are invalid.');
            } else {
                alert('Sorry, our payment processor reported an error. Contact support.')
            }
        } finally {
            this.stopSubmitting();
        }
    }

    async changeToPaymentCard() {
        TRACK_EVENT('Billing', 'Change Invoicing to Card');

        await this.getStripeCheckoutSession(true);
    }

    async showUpgradePlan(planName) {
        const planPrice = this.getPrices(planName, this.publicSelectedPeriod()).filter(i => i.MAUs == this.selectedMaus())[0];

        if (!planPrice) {
            this.showToast('Purchasing error, please contact us.')
            return;
        }

        await this.showUpgradePlanById(planPrice.Id);
    }

    async showUpgradePlanById(planId) {
        const plan = this.allPricingPlans.filter(x => x.id === planId)[0];

        var periodText;
        switch (plan.period) {
            case 1:
                periodText = 'Monthly'
                break;
            case 2:
                periodText = 'Annual'
                break;
        }

        this.upgradePlanId(plan.id);
        this.upgradePlanName(plan.name);
        this.upgradePlanPeriod(periodText);
        this.upgradePlanMaus(plan.maUs);
        this.upgradePlanPrice(plan.price);
        this.upgradePlanCurrency(plan.currency);

        $('#upgrade-plan-dialog').modal({
            backdrop: 'static'
        })
    }

    async upgradePlan() {
        this.startSubmitting();

        const response = await fetch('/stripe/updatepricingplan', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                pricingPlanId: this.upgradePlanId(),
                q: this.upgradePlanMaus(),
            })
        });
        if (response.ok) {
            window.location.reload();
        } else {
            alert("There was a problem with changing your plan. Please check your credit card and try again. If the problem persists, contact Product Fruits support.");
            this.stopSubmitting();
        }
    }

    async getStripeCheckoutSession(tryToChangeFromCurrentPlan = false) {
        if (this.presaveChecks()) return;

        TRACK_EVENT('Billing', 'Stripe - Go to Checkout session', { pricingPlanId: this.lastSelectedPlan(), q: this.lastSelectedQ() });
        TRACK_EVENT('Conversion', 'InitiateCheckout');

        // Create an instance of the Stripe object with your publishable API key
        const stripe = Stripe(this.getServerSideData('stripePublicToken'));

        this.startSubmitting();

        try {
            // Create a new Checkout Session using the server-side endpoint you
            // created in step 3.
            const response = await fetch('/stripe/createcheckoutsession', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    address: ko.mapping.toJS(this.data),
                    pricingPlanId: this.lastSelectedPlan(),
                    q: this.lastSelectedQ(),
                    tryToChangeFromCurrentPlan: tryToChangeFromCurrentPlan === true // ko type check
                })
            });
            const session = await response.json();

            if (response.status == 400) {
                if (session.error == 2) {
                    this.invalidVat(true);
                } else {
                    alert('Some fields are invalid.');
                }
                this.stopSubmitting();
                return;
            }
            const result = await stripe.redirectToCheckout({ sessionId: session.id });

            // If `redirectToCheckout` fails due to a browser or network
            // error, you should display the localized error message to your
            // customer using `error.message`.
            if (result.error) {
                alert(result.error.message);
            }
        }
        catch (error) {
            this.stopSubmitting();
            console.error('Error:', error);
            if (error && error.error == 1) {
                alert('Error - some fields are invalid.');
            } else {
                alert('Sorry, our payment processor reported an error. Contact our support.')
            }
        } finally {
            this.stopSubmitting();
        }
    }
}

export default SettingsBillingView;

class CancelRequestDialog {
    constructor() {

        this.isSending = ko.observable(false);
        this.reason = ko.observable('');
        this.choice = ko.observable();

        this.isEmpty = ko.computed(() => {
            return !this.choice() && !this.reason();
        });
    }

    send() {
        this.isSending(true);

        fetch('/stripe/cancelsubscription?f=' + (encodeURIComponent(this.reason()) || '') + '&c=' + this.choice(), {
            method: 'POST'
        }).then(() => {
            window.location.reload();
        });
    }
}

function onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
}
